"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = void 0;
const React = __importStar(require("react"));
const pie_1 = require("@nivo/pie");
const material_1 = require("@mui/material");
const getPadAngle = (innerRadius) => {
    if (innerRadius)
        return innerRadius;
    return 0;
};
const getLegends = (enableLegend) => {
    return enableLegend
        ? [
            {
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateX: 0,
                translateY: 56,
                itemsSpacing: 0,
                itemWidth: 100,
                itemHeight: 18,
                itemTextColor: '#999',
                itemDirection: 'left-to-right',
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000',
                        },
                    },
                ],
            },
        ]
        : undefined;
};
exports.PieChart = (props) => {
    const { data, innerRadius, padAngle, cornerRadius, enableLegend, enableArcLinkLabels, enableSliceLabels } = props;
    return (React.createElement(pie_1.ResponsivePie, { data: data, margin: { top: 40, right: 80, bottom: 80, left: 80 }, innerRadius: innerRadius || 0, padAngle: getPadAngle(padAngle), cornerRadius: cornerRadius || 3, enableRadialLabels: enableArcLinkLabels || false, enableSliceLabels: enableSliceLabels || false, legends: getLegends(enableLegend), tooltip: ({ datum: { id, value } }) => (React.createElement(material_1.Box, { style: {
                textAlign: 'center',
                padding: 12,
                color: 'white',
                background: '#474D66',
                borderCollapse: 'collapse',
                borderRadius: '6px',
            } },
            React.createElement(material_1.Typography, { display: "block" }, id),
            React.createElement(material_1.Typography, { display: "block" },
                value,
                "%"))) }));
};
//# sourceMappingURL=data:application/json;base64,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